import ResultsClientWithKeycloak from '../common/ResultsClientWithKeycloak';

export class Idel2ResultsClientWithKeycloak extends ResultsClientWithKeycloak {
    static BASE_URL = '/idel2-api/results/v1/results';
}

export default Idel2ResultsClientWithKeycloak;
